import React from 'react';
import styles from '../SaleReportPage.module.scss';

function ChipRadio({ options, value, onChange }) {
  return (
    <div className={styles.chipRow}>
      {options.map((opt) => {
        const isOn = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            className={`${styles.chipRadio} ${isOn ? styles.chipRadioOn : ''}`}
            onClick={() => onChange(opt.value)}
          >
            <span className={styles.chipDot} />
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}

export default ChipRadio;
